<section class="board-demo-panel" *ngIf="data" #panelEl>
  <!--><top-wave></top-wave><!-->
  <div class="board-demo-panel__content">
    <div class="board-demo-panel__row">
      <div class="board-demo-panel__col">
        <h2 class="board-demo-panel__title" *ngIf="data.title" #titleEl>{{ data.title.value }}</h2>
        <div *ngIf="data.description"
             class="board-demo-panel__description"
             [innerHTML]="data.description.value"
             class="board-demo-panel__description"
             #descriptionEl>
        </div>
      </div>
      <form [formGroup]="demoGroup" (ngSbumit)="sendRequest($event)" class="board-demo-panel__col">
        <div>
          <p><input class="board-demo-panel__contact-form" formControlName="name" type="text" [placeholder]="formText.name" /></p>
          <p><input class="board-demo-panel__contact-form" formControlName="email" type="email" [placeholder]="formText.email" /></p>
          <p><input class="board-demo-panel__contact-form" formControlName="phone" type="text" [placeholder]="formText.phone" /></p>
          <p><input class="board-demo-panel__contact-form" formControlName="company" type="text" [placeholder]="formText.company" /></p>
          <div class="board-demo-panel__consent">
            <input type="checkbox" formControlName="privacyPolicy" />
            <p> {{ "boardDemoPanel.PrivacyPolicy.Label" | translate }} <a *ngIf="data.cookiePolicyPageUrl" [routerLink]="data.cookiePolicyPageUrl" target="_blank"> {{ "boardDemoPanel.PrivacyPolicy.Link" | translate }} </a> </p>
          </div>
          <br />
          <br />
          <re-captcha (resolved)="reCaptchaValidated($event)" #captcha="reCaptcha" siteKey="{{data.reCaptchaSecret}}"></re-captcha>
          <div class="board-demo-panel__submit">
            <p *ngIf="errMsg" class="board-demo-panel__error">{{ errMsg }}</p>
            <p><button class="board-demo-panel__button bg-white-button" (click)="sendRequest($event)">{{ formText.submit }}</button></p>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div *ngIf="requestSuccess === true" class="board-demo-panel__modal">
    <div class="board-demo-panel__modal--content">
      <p>{{ succMsg }}</p>
    </div>
  </div>
</section>
